
          import $$Component from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/PromotionSetting.vue?vue&type=script"
          
          import { render } from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/PromotionSetting.vue?vue&type=template"
          export * from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/PromotionSetting.vue?vue&type=template"
          $$Component.render = render
          export default $$Component